import { render } from "./rateCreate.vue?vue&type=template&id=57d93cf3&scoped=true"
import script from "./rateCreate.vue?vue&type=script&lang=js"
export * from "./rateCreate.vue?vue&type=script&lang=js"

import "./rateCreate.vue?vue&type=style&index=0&id=57d93cf3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d93cf3"]])

export default __exports__